import React, { useState, useEffect } from "react";
import {
  SelectedOrganisationId,
  societeId,
} from "../../_App/Redux/Slices/Auth/authSlice";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import {
  findFidelitePrograms,
  findNiveauxFidelite,
  findZonesByOrganisation,
  ListProgramFidelite,
} from "../../_App/Redux/Slices/client/clientSlice";
import { useTranslation } from "react-i18next";
import Navbar from "../../_Layouts/Navbar/Navbar";
import Swal from "sweetalert2";
import FideliteTable from "../../Components/Client/ProgramFidleiteTable";
import ProgramFideliteForm from "../../Components/Client/ProgramFideliteForm";
const FidelitePage = () => { 
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  const currentOrg = useAppSelector(SelectedOrganisationId);
  const societe = useAppSelector(societeId);

  const [showModal, setShowModal] = useState(false);
  const [item, setItem] = useState(null);

  const fidelites = useAppSelector(ListProgramFidelite);

  useEffect(() => {
    if (currentOrg && societe) {
      dispatch(findFidelitePrograms(societe));
      dispatch(findNiveauxFidelite(societe));
      dispatch(findZonesByOrganisation(currentOrg));
    }
  }, [dispatch, showModal]);

  const updateFunction = (item: any) => {
    setItem(item);
    setShowModal(true);
  };
  useEffect(()=>{
    if(!showModal){
      setItem(null)
    }
  },[showModal])
  const verifcationMsg = (msg: string) => {
    return Swal.fire({
      title: t("vous-êtes sûr?"),
      text: msg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("Confirmer!"),
      cancelButtonText: t("Cancel!"),
    }).then((result) => {
      return result.isConfirmed ? true : false;
    });
  };

  return (
    <div>
      <Navbar />

      <div className="d-flex justify-content-end mb-3 mt-5">
        <button
          className="btn btn-primary-app"
          onClick={() => setShowModal(true)}
        >
          {t("Ajouter un programme de fidelité")}
        </button>
      </div>
      <ProgramFideliteForm
        t={t}
        verifcationMsg={verifcationMsg}
        ShowModal={showModal}
        setShowModal={setShowModal}
        programFidelite={item}
      />
      {fidelites && fidelites.length !== 0 ? (
        <FideliteTable
          t={t}
          ProgramsFidelites={fidelites}
          setItem={setItem}
          updateFunction={updateFunction}
        />
      ) : (
        <p>aucun programme fidelite</p>
      )}
    </div>
  );
};

export default FidelitePage;
